/**
 * Route /cities/:id — öffentliche Stadt-Detailseite (Städteseiten-Relaunch 09.2026)
 *
 * v1-Zahlen (nginx-Logs vor dem 04.09.2026-Relaunch): 128.733 Aufrufe auf
 * /cities/:id. Bewusst AUSSERHALB von `_auth`, gleiches Muster wie
 * hotspots.$id.tsx.
 */
import { createFileRoute } from '@tanstack/react-router'
import { CityDetail } from '../features/cities/CityDetail'
import { PublicOrAppShell } from '../layouts/PublicOrAppShell'

export const Route = createFileRoute('/cities/$id')({
  component: CityDetailRoutePage,
})

function CityDetailRoutePage() {
  const { id } = Route.useParams()

  return (
    <PublicOrAppShell>
      <CityDetail id={id} />
    </PublicOrAppShell>
  )
}
